export default __webpack_public_path__ + "static/media/2038_v1_500.c92a6e2b.jpg";